{
  "starterBalance": "$0.10",
  "welcomeGift": "$0.02",
  "starterRequests": "~100",
  "agentTrialBudget": "$0.05",
  "agentTrialDays": 7
}
